import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import PortfolioSetup from "Administrator/routes/Settings/routes/PortfolioManager/routes/PortfolioSetup";
import ActivitySettings from "Administrator/routes/Settings/routes/PortfolioManager/routes/ActivitySettings";
import PortfolioSettings from "Administrator/routes/Settings/routes/PortfolioManager/routes/Settings";
import PortfolioReviewSetup from "Administrator/routes/Settings/routes/PortfolioManager/routes/ReviewerSetup";
import { injectReducer } from "store/reducers";

export default store => {
  return {
    path: "portfolio-module-settings",
    component: withAsyncRouteLoading(() =>
      Promise.all([
        import(
          /* webpackChunkName: "portfolio-settings-tab" */ "AppComponents/AdminNavigation/components/SchoolTabLayout"
        ),
        import(
          /* webpackChunkName: "admin-portfolio-manager" */ "Administrator/routes/Settings/routes/PortfolioManager/routes/TeacherPortfolio/modules/TeacherPortfolioModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;

        injectReducer(store, {
          key: "teacherPortfolio",
          reducer: importedModule1,
        });
        return component;
      })
    ),
    childRoutes: [
      PortfolioSetup(store),
      ActivitySettings(store),
      PortfolioSettings(store),
      PortfolioReviewSetup(store),
    ],
  };
};
